import { type Context, createContext } from 'react';

import { DismissiblePagePanels } from '../types/shared-page-types.js';

export interface PanelContextProps {
  panelName?: DismissiblePagePanels;
}

/** The PanelContext is used to tell where the PagePanelControl is rendered. */
export const PanelContext: Context<PanelContextProps> =
  createContext<PanelContextProps>({});
PanelContext.displayName = 'PanelContext';
